import logger from './logger';
/**
 * Generates the Firestore collection path based on user, family, and storage parameters
 * @param {string} userId - The user's ID
 * @param {string} familyCode - The family code
 * @param {string} collectionType - The type of collection (e.g., 'documents', 'photos')
 * @param {string} storageArea - The storage area ('personal', 'family', 'vault')
 * @returns {string} The Firestore collection path
 */
export const getFirestorePath = (userId, familyCode, collectionType, storageArea) => {
  // Validate inputs
  if (!userId) throw new Error('User ID is required');
  if (!collectionType) throw new Error('Collection type is required');
  
  switch (storageArea) {
    case 'personal':
      return `users/${userId}/${collectionType}`;
    case 'family':
      if (!familyCode) throw new Error('Family code is required for family storage area');
      return `users/${userId}/${collectionType}`; // Family code will be in metadata
    case 'vault':
      if (!familyCode) throw new Error('Family code is required for vault storage area');
      return `users/${userId}/${collectionType}`; // Vault type will be in metadata
    default:
      logger.warn(`Invalid storage area: ${storageArea}, defaulting to personal`);
      return `users/${userId}/${collectionType}`;
  }
}; 